<template>
  <!-- Workspace Section-->
  <div class="nav-section">
    <h2>My Workspaces</h2>
    <!-- Workspace content wrapper with border -->
    <div class="workspace-content">
      <ul class="workspace-acc">
        <li :class="{ active: isWorkspaceViewActive }">
          <a href="#" class="acc-opener" @click="toggleWorkspaceView">{{
            activeWorkspaceName
          }}</a>
          <div class="acc-drop">
            <ul class="workspace-list">
              <li
                v-for="(workspace, index) in workspaces"
                :key="index"
                :class="{
                  active: activeWorkspaceUUID === workspace.workspaceUUID,
                }"
              >
                <a
                  href="#"
                  @click="handleWorkspaceSelection(workspace.workspaceUUID)"
                >
                  <span>{{ workspace.initials }}</span
                  >{{ workspace.name }}
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <!-- Add New Workspace button only shown when dropdown is open -->
      <a
        v-if="isWorkspaceViewActive"
        href="#"
        class="add-link"
        :class="{ disabled: !canCreateWorkspace }"
        @click="handleAddWorkspaceClick"
      >
        + Add a New Workspace
        <span v-if="!canCreateWorkspace" class="limit-text">
          <span v-if="isSubscribed">(Limit: 3)</span>
          <span v-else>
            (<router-link
              to="/settings/plans"
              class="upgrade-link-inline"
              @click="trackUpgradeClicked"
              >Upgrade for more</router-link
            >)
          </span>
        </span>
      </a>
    </div>
  </div>
  <!-- End Workspace Section-->
</template>

<script>
import { useAppStore } from "@/stores/app-store";
import { useWorkSpaceStore } from "@/stores/workspace-store";
import { analytics } from "@/services/analytics.service";

export default {
  name: "NavWorkspaces",
  data() {
    return {
      isWorkspaceViewActive: false,
    };
  },
  methods: {
    toggleWorkspaceView(event) {
      event.preventDefault();
      this.isWorkspaceViewActive = !this.isWorkspaceViewActive;

      // Track dropdown open/close
      if (this.isWorkspaceViewActive) {
        analytics.workspaceDropdownOpened();
      } else {
        analytics.workspaceDropdownClosed();
      }
    },
    setActiveWorkspace(uuid) {
      const workspaceStore = useWorkSpaceStore();
      workspaceStore.setActiveWorkspace(uuid); // Update active workspace in store and localStorage
    },
    handleWorkspaceSelection(uuid) {
      const workspace = this.workspaces.find((w) => w.workspaceUUID === uuid);

      // Track workspace selection
      analytics.workspaceSelected({
        workspace_uuid: uuid,
        workspace_name: workspace?.name || "Unknown",
      });

      this.setActiveWorkspace(uuid);
      this.isWorkspaceViewActive = false; // Close the dropdown
    },
    toggleNewWorkspacePopup() {
      const appStore = useAppStore();
      appStore.showNewWorkspacePopup = !appStore.showNewWorkspacePopup;
    },
    handleAddWorkspaceClick(event) {
      event.preventDefault();

      // Track add workspace clicked
      analytics.addWorkspaceClicked({
        current_workspace_count: this.workspaces.length,
        is_at_limit: !this.canCreateWorkspace,
      });

      if (this.canCreateWorkspace) {
        this.toggleNewWorkspacePopup();
      } else {
        // Track workspace limit reached
        analytics.limitWorkspaceReached({
          workspace_limit: this.workspaceLimit,
          current_count: this.workspaces.length,
        });
      }
    },
    trackUpgradeClicked() {
      analytics.workspaceLimitUpgradeClicked({
        current_workspace_count: this.workspaces.length,
      });
    },
  },
  computed: {
    // Access stores directly in the template without mapping.
    workspaces() {
      return useWorkSpaceStore().workspaces;
    },
    activeWorkspaceUUID() {
      return useWorkSpaceStore().activeWorkspaceUUID;
    },
    activeWorkspaceName() {
      return useWorkSpaceStore().activeWorkspaceName || "My Workspaces";
    },
    isSubscribed() {
      return useWorkSpaceStore().isSubscribedState;
    },
    canCreateWorkspace() {
      return useWorkSpaceStore().canCreateWorkspace;
    },
    workspaceLimit() {
      return useWorkSpaceStore().workspaceLimit;
    },
  },
};
</script>
